var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ViewMode } from '../../models/view-mode.enum';
import { ViewActions } from '../../state/view.actions';
import { ViewState } from '../../state/view.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Fullscreen } from 'src/app/shared/libraries/fullscreen/fullscreen';
import { ViewService } from '../../view.service';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { EngineState } from 'src/app/engine/state/engine.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { HistoryService } from 'src/app/history/history.service';
var MenuModeStatus;
(function (MenuModeStatus) {
    MenuModeStatus[MenuModeStatus["Opened"] = 0] = "Opened";
    MenuModeStatus[MenuModeStatus["Closed"] = 1] = "Closed";
    MenuModeStatus[MenuModeStatus["Reset"] = 2] = "Reset";
})(MenuModeStatus || (MenuModeStatus = {}));
export class ViewMenuComponent {
    // ---------- Lifecycle Hooks ----------
    constructor(store, viewService, layoutService, historyService, changeDetectorRef) {
        this.store = store;
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.historyService = historyService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.open = false;
        this.canReset = false;
        this.menuMode = MenuModeStatus.Closed;
        this.menuModeStatus = MenuModeStatus;
        this.viewMode = ViewMode;
        this.viewLayout = ViewLayout;
        this.canFullscreen = true;
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.canFullscreen = Fullscreen.canFullscreen();
        this.initLayoutListener();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    initLayoutListener() {
        this.store.select(ViewState.getLayout)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(layout => {
            const drawerMode = this.viewService.inferDrawerMode(layout);
            const menuMode = (drawerMode !== ViewMode.Content || layout.search.status === ViewLayoutStatus.Show) ?
                MenuModeStatus.Reset : MenuModeStatus.Closed;
            this.toggleMenu(menuMode);
        });
    }
    handleMenuClick(menuMode) {
        this.toggleMenu(menuMode);
    }
    handleSearchClick() {
        this.toggleMenu(MenuModeStatus.Reset);
        this.viewService.toggleSearch();
    }
    handleToolsClick() {
        this.toggleMenu(MenuModeStatus.Reset);
        const layout = this.store.selectSnapshot(ViewState.getLayout);
        layout.tools.status = ViewLayoutStatus.Show;
        this.store.dispatch(new ViewActions.SetLayout(layout));
    }
    handleFullscreenClick() {
        this.closeMenu();
        Fullscreen.toggleFullscreen();
    }
    handlePresentationClick() {
        this.closeMenu();
        this.viewService.togglePresentation();
    }
    handleHelpClick() {
        this.closeMenu();
        this.viewService.toggleHelp();
    }
    handleNewTabClick() {
        this.viewService.openInNewTab();
    }
    handleToggleLabelsClick() {
        this.viewService.toggleLabels();
    }
    handleResetMenuClick() {
        this.closeMenu();
        this.viewService.resetLayout();
    }
    handleResetSceneClick() {
        this.historyService.resetChapter();
    }
    closeMenu() {
        this.toggleMenu(MenuModeStatus.Closed);
    }
    toggleMenu(menuMode) {
        if (menuMode == null) {
            menuMode = this.menuMode === MenuModeStatus.Closed ? MenuModeStatus.Opened : MenuModeStatus.Closed;
        }
        this.menuMode = menuMode;
        this.changeDetectorRef.markForCheck();
    }
    isEnabled(layout) {
        return this.layoutService.isLayoutEnabled(layout);
    }
}
__decorate([
    Select(StoryLabelsState.getChapterLabels),
    __metadata("design:type", Observable)
], ViewMenuComponent.prototype, "labels$", void 0);
__decorate([
    Select(EngineState.getShowLabels),
    __metadata("design:type", Observable)
], ViewMenuComponent.prototype, "showLabels$", void 0);
